import React from 'react';
import { useApp } from './lib/app-context';
import { Shell } from './components/Shell';
import { Landing } from './screens/Landing';
import { Onboarding } from './screens/Onboarding';
import { Dashboard } from './screens/Dashboard';
import { Lesson } from './screens/Lesson';
import { Vocabulary } from './screens/Vocabulary';
import { Grammar } from './screens/Grammar';
import { Skills } from './screens/Skills';
import { Review } from './screens/Review';
import { Boss } from './screens/Boss';
import { Knowledge } from './screens/Knowledge';
import { Stats } from './screens/Stats';
import { Profile } from './screens/Profile';
import { Pricing } from './screens/Pricing';
import { Login } from './screens/Login';
import { Admin } from './screens/Admin';

export default function App(){
  const {ready,authenticated,route,state}=useApp();
  if(!ready)return <div className="boot">
    <div className="boot-logo-wrap">
      <picture>
        <source srcSet="/brand/app_icon_96.webp?v=3.1.1-audit 96w, /brand/app_icon_192.webp?v=3.1.1-audit 192w" sizes="96px" type="image/webp" />
        <img
          className="boot-logo"
          src="/brand/app_icon.png?v=3.1.1-audit"
          alt="English Forge 365"
          width={96}
          height={96}
          loading="eager"
          decoding="async"
          fetchPriority="high"
        />
      </picture>
      <span className="boot-loader"/>
    </div>
    <strong>English Forge 365</strong>
    <span>Learning Engine yuklanmoqda...</span>
  </div>;
  if(route==='landing')return <Landing/>;
  if(route==='pricing')return <Pricing/>;
  if(route==='login')return <Login/>;
  if(route==='admin')return <Admin/>;

  // Web/PWA app authenticated account talab qiladi.
  // Telegram Mini App authenticated=true bo'ladi.
  if(!authenticated)return <Login/>;

  if(!state.profile.onboardingComplete)return <Onboarding/>;
  const screen = route==='lesson'?<Lesson/>
    :route==='vocabulary'?<Vocabulary/>
    :route==='grammar'?<Grammar/>
    :route==='skills'?<Skills/>
    :route==='review'?<Review/>
    :route==='boss'?<Boss/>
    :route==='knowledge'?<Knowledge/>
    :route==='stats'?<Stats/>
    :route==='profile'?<Profile/>
    :<Dashboard/>;
  return <Shell>{screen}</Shell>;
}
